import { CheckboxOptionType } from 'antd/lib/checkbox/Group';
import { SuperFormItemProps } from '../../../../SuperForm/interface';
import { IOptionalFormItems } from "../../../interface";

export function getFormItems(formItems: IOptionalFormItems[], onChange: (name: string, checkedValue: any[]) => void): SuperFormItemProps[] {
  const newFormItem: SuperFormItemProps[] = [];
  formItems.forEach(formItem => {
    const children = formItem.children;
    const options: CheckboxOptionType[] = [];
    children.forEach(item => {
      const itemName = item.name;
      if (typeof itemName === 'string') {
        options.push({
          label: item.label,
          value: itemName,
          disabled: item.disabled,
        });
      }
    });
    newFormItem.push({
      label: formItem.label,
      name: formItem.value,
      formItemType: 'CheckboxGroup',
      checkboxGroupProps: {
        options,
        onChange: (checkedValue: any[]) => {
          onChange(formItem.value, checkedValue);
        },
      },
    });
  });
  return [
    {
      label: '可选条件',
      formItemType: 'Group',
      children: newFormItem,
    },
  ];
}